import * as XLSX from 'xlsx'

const columnGroups = {
  factoryName: [['factory', '所属工厂']],
  gpuType: [['gpu', 'GPU 类型']],
  connectionState: [['connection', '连接状态'], ['work', '工作状态']],
  health: [['health', '健康与异常'], ['errorCount', '历史异常数量'], ['auth', '鉴权状态']],
  versionName: [['version', '软件版本'], ['model', '模型名称']],
  lastHeartbeatAt: [['heartbeat', '最近上报时间']]
}

export const createDashboardWorkbook = plan => {
  const columns = [['name', '设备名称'], ['type', '设备类型'], ['port', '设备端口'], ['serial', '序列号']]
  plan.visibleColumnKeys.forEach(key => {
    if (columnGroups[key]) columns.push(...columnGroups[key])
  })
  // aoa_to_sheet keeps user-provided strings as text, including leading '='.
  const sheet = XLSX.utils.aoa_to_sheet([
    columns.map(column => column[1]),
    ...plan.rows.map(row => columns.map(column => row[column[0]] == null ? '' : row[column[0]]))
  ])
  sheet['!cols'] = columns.map(() => ({ wch: 24 }))
  sheet['!autofilter'] = { ref: sheet['!ref'] }
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, sheet, '设备列表')
  const infoSheet = XLSX.utils.aoa_to_sheet([
    ['项目', '内容'],
    ['导出范围', plan.scopeLabel],
    ['设备数量', plan.rows.length],
    ['看板数据时间', plan.generatedAt || '未提供'],
    ['筛选条件', plan.filters || '无'],
    ['异常统计范围', `最近 ${plan.windowHours} 小时`],
    ['数据说明', plan.note]
  ])
  infoSheet['!cols'] = [{ wch: 22 }, { wch: 90 }]
  XLSX.utils.book_append_sheet(workbook, infoSheet, '导出说明')
  return workbook
}

export const downloadDashboardExport = plan => {
  const stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/T/, '_').slice(0, 15)
  XLSX.writeFile(createDashboardWorkbook(plan), `设备看板_${plan.scope === 'selected' ? '已选设备' : '筛选结果'}_${stamp}.xlsx`)
}
